import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const GaugeRenderer = ({ data, config, compact }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <div className="dc-no-data">No gauge data</div>;
  }

  const item = data[0];
  // Robust detection for value and max
  const value = item.value ?? Object.values(item).find(v => typeof v === 'number') ?? 0;
  const max = item.max ?? config?.max ?? 100;
  
  const gaugeData = [
    { name: 'Value', value: value, color: 'var(--accent-primary)' },
    { name: 'Remaining', value: Math.max(0, max - value), color: 'var(--bg-tertiary)' }
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart margin={compact ? { top: 0, right: 0, left: 0, bottom: -40 } : { top: 20, right: 20, left: 20, bottom: -40 }}>
        <Pie
          data={gaugeData}
          cx="50%"
          cy="70%" // Push it down since it's a half pie
          startAngle={180}
          endAngle={0}
          innerRadius={compact ? 40 : 80}
          outerRadius={compact ? 60 : 110}
          paddingAngle={0}
          dataKey="value"
          stroke="none"
        >
          {gaugeData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip contentStyle={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-primary)', borderRadius: '8px' }} />
        {/* Render centered text */}
        <text x="50%" y="65%" textAnchor="middle" dominantBaseline="middle" fill="var(--text-primary)" style={{ fontSize: compact ? '20px' : '32px', fontWeight: 'bold' }}>
          {value}{config?.unit || '%'}
        </text>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default GaugeRenderer;
